import React, { useEffect, useState } from 'react';

const SLIDE_MS = 7000;

export default function HeroCarousel({ slides = [] }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const t = setTimeout(() => setI((n) => (n + 1) % slides.length), SLIDE_MS);
    return () => clearTimeout(t);
  }, [i, slides.length]);

  if (!slides.length) return null;
  const current = slides[i];

  return (
    <div className="absolute inset-0" data-testid="hero-carousel">
      {slides.map((slide, idx) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={idx === i ? (slide.alt || '') : ''}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ opacity: idx === i ? 1 : 0, transition: 'opacity 0.8s ease' }}
          fetchPriority={idx === 0 ? 'high' : 'auto'}
          decoding="async"
        />
      ))}
    </div>
  );
}
